module.exports = __webpack_public_path__ + "static/media/passport.3507cf72.png";